var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',{staticClass:"indoorSettingImg"},[_c('indoor-setting',{attrs:{"category-tag-id":_vm.tagSelected,"space-id":_vm.currentSpaceInfo.id},on:{"showDeviceDetail":_vm.showDetail}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }